import React, { useEffect } from "react";
import { Field, Form, Formik } from "formik";
import {
  CheckBox,
  GalleryField,
  TextField,
  Select,
  Loading,
} from "components/form";
import { required, validationWrapper, number } from "lib/formValidations";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { generate_uuid } from "lib/helpers";
import axios from "axios";
import * as Icons from "react-feather";
import { TextArea } from "components/form";
const AddSlide = ({ show, close, submit }) => {
  const core = useCore();

  useEffect(() => {
    // core.dispatch(core.getProducts());
  }, []);
  return (
    <Modal show={show} title="افرزودن اسلاید" handleClose={close}>
      <Formik
        initialValues={{}}
        onSubmit={(values) => {
          submit(values);

          close();
        }}
        enableReinitialize
      >
        {({ form, isSubmitting, dirty, values, setFieldValue }) => (
          <Form>
            <div className="box rounded py-3">
              <div className="p-3 justify-aroundintro-x">
                <div className="col-span-2 md:grid md:grid-cols-2 md:gap-2">
                  <Field
                    label="ترتیب نمایش"
                    name="order"
                    component={TextField}
                    type="number"
                    validate={(value) => validationWrapper(value, number)}
                  />
                  <Field
                    placeholder="لینک"
                    label="لینک :"
                    name="link"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان اسلاید"
                    label="عنوان اسلاید :"
                    name="translations.fa.title"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان انگلیسی"
                    label="عنوان انگلیسی :"
                    name="translations.en.title"
                    component={TextField}
                  />

                  <Field
                    placeholder="عنوان لینک"
                    label="عنوان لینک :"
                    name="translations.fa.linkTitle"
                    component={TextField}
                  />
                  <Field
                    placeholder="عنوان لینک"
                    label="عنوان لینک :"
                    name="translations.en.linkTitle"
                    component={TextField}
                  />

                  <Field
                    placeholder="توضیحات"
                    label="توضیحات :"
                    name="translations.fa.summary"
                    component={TextArea}
                  />
                  <Field
                    placeholder="توضیحات انگلیسی"
                    label="توضیحات انگلیسی :"
                    name="translations.en.summary"
                    component={TextArea}
                  />
                </div>

                <div className="w-full flex justify-between">
                  <div className="w-full mt-3">
                    <Field
                      label="مدیا"
                      name="media"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <button className="btn btn-sm btn-primary" type="submit">
                  ایجاد اسلاید
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddSlide;
